/* eslint no-console:0 */

import './application/jquery'
import 'jquery-ujs'

import 'unpoly/unpoly'
import 'unpoly/unpoly.css'
import 'unpoly/unpoly-bootstrap4'
import 'unpoly/unpoly-bootstrap4.css'


import 'flatpickr/dist/flatpickr.min.css'
import 'mobius1-selectr/dist/selectr.min.css'

import 'blueimp-file-upload'

import './frontend/stylesheets/normalize.scss'
import './frontend/stylesheets/fonts.sass'
import './frontend/stylesheets/application.sass'
import './frontend/stylesheets/shared.sass'
import './frontend/stylesheets/*/**/*.sass'

import './shared/**/*.js'
import './frontend/unpoly_config'
import './frontend/javascripts/**/*.js'
